"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_ADI_CHANNEL = '9bf7ba3816de4423963e7d6e23c072e0';
var isDefaultADIChannel = function (channelId) {
    return channelId === DEFAULT_ADI_CHANNEL;
};
exports.default = isDefaultADIChannel;
//# sourceMappingURL=is-default-adi-channel.js.map